import { Button, Center, Loader, Table, Text } from "@mantine/core";
import { IconArrowLeft, IconArrowRight } from "@tabler/icons";
import { useNavigate, useParams } from "react-router-dom";
import {getApiStepGetStepById, getApiStepGetSteps, useGetApiStepGetSteps} from "../../api/endpoints";
import { useTranslation } from "react-i18next";
import {useAccessToken, useAuth} from "../../auth/AuthContext";
import useApi from "../../utils/useApi";
import {Step} from "../../api/model";

function StepsListReport() {
    const auth = useAuth();
    const [accessToken, updateAccessToken] = useAccessToken();

    const navigate = useNavigate();
  const params = useParams();
  const { t } = useTranslation();
  // const { data: steps } = useGetApiStepGetSteps({
  //   callTypeId: params.callTypeId,
  // });

    const {
        data: steps,
        setData: setSteps,
        loading: isLoadingSteps,
        setLoading: setIsLoadingSteps,
        error: errorSteps,
        setError: setErrorSteps,
    } = useApi<Step[]>(() => getApiStepGetSteps({callTypeId: params.callTypeId}), [params.callTypeId]);

  if (!steps) {
    return (
      <Center>
        <Loader />
      </Center>
    );
  }
    if (isLoadingSteps || !accessToken) {
        return (
            <Center>
                <Loader />
            </Center>
        );
    }
    if (errorSteps) {
        return (
            <Center>
                Errore
            </Center>
        );
    }
console.log(steps);
  const StepList = () => {
    return (
      <Table mt={20}>
        <tbody>
          {steps.sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0)).filter((s) => s.stepType!.name == "survey").length ? (
            steps
              .filter((s) => s.stepType!.name == "survey")
              .map((s) => {
                return (
                  <tr key={s.id} style={{ paddingTop: 20, paddingBottom: 20 }}>
                    <td>{s.name}</td>
                    <td>
                      <Button
                        variant="subtle"
                        color="blue"
                        rightIcon={<IconArrowRight />}
                        radius="sm"
                        style={{ float: "right", marginRight: "20px" }}
                        onClick={() => {
                          navigate(`/admin/report/${params.callId}/${s.id}`);
                        }}
                      >
                        {t("pages.admin.go-report")}
                      </Button>
                    </td>
                  </tr>
                );
              })
          ) : (
            <Center>
              <Text>
                        {t("pages.admin.no-survey-call")}
              </Text>
            </Center>
          )}
        </tbody>
      </Table>
    );
  };

  return (
    <>
      <Button
        variant="subtle"
        style={{ marginLeft: -14 }}
        leftIcon={<IconArrowLeft />}
        onClick={() => navigate("/admin", { state: "calls" })}
      >
        {t("pages.admin.go-back")}
      </Button>
      <StepList />
    </>
  );
}

export default StepsListReport;
